"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const router_1 = require("@angular/router");
const material_1 = require("@angular/material");
const app_service_1 = require("../commons/app.service");
const core_1 = require("@ngx-translate/core");
const AppBaseComponent_1 = require("../commons/AppBaseComponent");
const _4d_mapper_1 = require("4d-mapper");
// generic helpers
const Constants_1 = require("./../commons/Constants");
const application_events_service_1 = require("../xs/services/events/application-events.service");
class ProfileComponent extends AppBaseComponent_1.AppBaseComponent {
    constructor(fourD, service, router, snackBar, dialog, translate, applicationEvents) {
        super(service, router, snackBar, dialog, applicationEvents);
        this.fourD = fourD;
        this.service = service;
        this.router = router;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.translate = translate;
        this.fields = [];
        this.password = {};
    }
    onReady() {
        var userMap = this.service.objectMetas.find(o => o.uid == 'User');
        this.translate.get(['PROFILE.NAME', 'PROFILE.EMAIL']).subscribe(r => {
            this.fields = this.service.siteSettings.userQMap || [{ id: 'name', title: r['PROFILE.NAME'], type: 'shorttext' },
                { id: 'email', type: 'shorttext', title: r['PROFILE.EMAIL'], disabled: true }];
        });
        // hide HangOn / waiting box (if open)
        Constants_1.Constants.hideHangOn();
    }
    uploadFile(event) {
        this.loading = true;
        let fileList = event.target.files;
        if (fileList.length > 0) {
            let file = fileList[0];
            fetch(this.fourD.V.config.host + "/api/User/" + this.service.myProfile.id + '/image.png', {
                method: 'POST',
                body: file,
                headers: {
                    'Content-type': 'application/binary',
                    Authorization: 'bearer ' + this.service.V.authToken()
                }
            }).then(r => {
                this.loading = false;
                // Reload the img src after file uplaoded to server
                this.imageDirective.updateLink();
            });
        }
        else {
            this.loading = false;
        }
    }
    changeName() {
        this.loading = true;
        this.service.myProfile.saveObservable().subscribe(res => {
            var ls = this.fourD.V.localSession();
            ls.user = this.service.myProfile;
            this.fourD.V.saveLocalSession(ls);
            this.loading = false;
            this.openSnackBarSuccess('PROFILE.UPDATED');
        }, err => {
            this.loading = false;
            this.openSnackBarError(this.error + ': ' + err.message);
        });
    }
    setpass() {
        this.pload = true;
        this.service.V.api('/api/me', 'put', this.password).subscribe(s => {
            this.pload = false;
            this.openSnackBarSuccess('PROFILE.PASSWORD_SET');
            this.password = {};
        }, e => {
            this.pload = false;
            this.openSnackBarError(e.message);
        });
    }
}
exports.ProfileComponent = ProfileComponent;
